import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { SwalService } from '../shared/services/swal.service';
import { AuthService } from '../services/auth.service';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})

export class CatchAllInterceptorService implements HttpInterceptor {

    constructor(
        private readonly router: Router,
        private readonly injector: Injector,
        public authService: AuthService,
        public swal: SwalService
    ) {
    }

	/**
	 * Intercept Handler
	 * @param request
	 * @param next
	 * @returns
	 */
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(req).pipe(
            catchError(httpError => {
                let errorMessage: any;
                let displayMessage: any;
                if (httpError instanceof ErrorEvent) {
                    // client-side error
                    errorMessage = `Client-side error: ${httpError.error.message}`;
                    this.swal.error({ text: errorMessage }).catch();
                } else {
                    if (httpError.error.error === 'user_not_found'
						|| httpError.error === 'token_invalid'
						|| httpError.error === 'token_error'
					) {
                        errorMessage = 'Sesion expirada';
                        this.authService.logout();
                        this.swal.warning({ title: 'Sesion expirada', text: '', showCancelButton: false, confirmButtonText: 'Ok' });
                        this.router.navigateByUrl('/login');
                    } else {

                        if (httpError.status === 401 && httpError.error === 'token_expired') {
                            const http = this.injector.get(HttpClient);
                            const token: string = localStorage.getItem('access_token');

                            return http.post<any>(`${environment.apis.base}/refresh`,
                                {},
                                {
                                    headers: {
                                        Authorization: `Bearer ${token}`
                                    }
                                })
                                .pipe(
                                    mergeMap(data => {
                                        localStorage.setItem('access_token', data.token);
                                        const cloneRequest = req.clone({
                                            setHeaders: {
                                                Authorization: `Bearer ${data.token}`
                                            }
                                        });

                                        return next.handle(cloneRequest);
                                    })
                                );
                            // tslint:disable-next-line: unnecessary-else
                        } else {

                            // backend error
                            errorMessage = `Server-side error: ${httpError.status} ${httpError.message}`;
                            const errors = [
                                `${httpError.status} - ${httpError.statusText}`,
                                httpError.url,
								httpError.error?.message
                            ];

                            displayMessage = '<div class="server-error">';
                            displayMessage += '<p>Server-side error:</p>';
                            displayMessage += `<ul>${this.returnFormated(errors)}</ul>`;
                            displayMessage += '</div>';

                            console.log(httpError.error);

                            switch (httpError.status) {
                                case 401:
                                    if (httpError.error.message === 'bad_credentials') {
                                        this.swal.error({
                                            title: 'Credenciales invalidas',
                                            text: '',
                                            showCancelButton: false,
                                            confirmButtonText: 'Ok'
                                        });
                                        break;
                                    }
                                    errorMessage = httpError;
                                    break;
                                case 402:
                                    const failure_messages = httpError.error.response.errors || [];
                                    displayMessage = '<div class="server-error">';
                                    // displayMessage += '<p>Vendor error:</p>';
                                    let errorsShow = '<li>Error al procesar el pago.</li>';
                                    if (failure_messages.length > 0) {
                                        const formatedErrors = this.returnFormated(failure_messages);
                                        if (formatedErrors !== '') {
                                            errorsShow = formatedErrors;
                                        }
                                    }
                                    displayMessage += `<ul>${errorsShow}</ul>`;
                                    displayMessage += '</div>';
                                    this.swal.error({ html: displayMessage });

                                    break;
                                default:
                                    // this.authService.logout();
                                    // this.router.navigateByUrl('/login');
                                    this.swal.error({ html: displayMessage }).catch();
                                    break;
                            }
                        }

                    }
                }

                // aquí podrías agregar código que muestre el error en alguna parte fija de la pantalla.
                // this.errorService.show(errorMessage);
                // console.warn(errorMessage);
                return throwError(errorMessage);
            })
        );
    }

	/**
	 * Format the errors in list format
	 * @param errors
	 * @returns
	 */
    returnFormated(errors: Array<any>): string {
        let text = '';
        errors.forEach(error => {
            if (Array.isArray(error) && error.length > 0) {
                error.forEach(subError => {
                    if (subError.hasOwnProperty('failure_message')) {
                        text += `<li>${subError.failure_message}</li>`;
                    } else  {
                        text += `<li>${subError}</li>`;
                    }
                });
            } else {
                text += `<li>${error}</li>`;
            }
        });

        return text;
    }
}
